<template>
    <component :is="template">
        <v-responsive width="100%">
            <v-card elevation="0" max-width="100%">
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">배송상품 구매내역</h2>
                </div>

                <div class="mb-4">
                    <v-row class="row--small">
                        <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                            <v-sheet :width="$vuetify.breakpoint.mobile ? '100%' : 150">
                                <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field :value="filter.createdAt[0]" append-icon="event" item-text="text" item-value="value" label="주문일시" readonly persistent-placeholder outlined dense hide-details color="primary" v-on="on" class="pt-0"></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="filter.createdAt[0]"
                                        type="date"
                                        no-title
                                        scrollable
                                        min="2010-01-01"
                                        max="2060-12-31"
                                        class="w-100"
                                        @input="
                                            () => {
                                                page = 1;
                                                search();
                                            }
                                        "
                                    ></v-date-picker>
                                </v-menu>
                            </v-sheet>
                        </v-col>
                        <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                            <v-sheet :width="$vuetify.breakpoint.mobile ? '100%' : 150">
                                <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field :value="filter.createdAt[1]" append-icon="event" item-text="text" item-value="value" label="주문일시" readonly persistent-placeholder outlined dense hide-details color="primary" v-on="on" class="pt-0"></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="filter.createdAt[1]"
                                        type="date"
                                        no-title
                                        scrollable
                                        min="2010-01-01"
                                        max="2060-12-31"
                                        class="w-100"
                                        @input="
                                            () => {
                                                page = 1;
                                                search();
                                            }
                                        "
                                    ></v-date-picker>
                                </v-menu>
                            </v-sheet>
                        </v-col>
                        <v-spacer />
                        <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                            <v-sheet :width="$vuetify.breakpoint.mobile ? '100%' : 180">
                                <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder outlined dense hide-details color="primary" @input="filter.searchValue = null" />
                            </v-sheet>
                        </v-col>
                        <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 'auto'">
                            <v-text-field
                                v-model="filter.searchValue"
                                label="검색어"
                                persistent-placeholder
                                outlined
                                dense
                                hide-details
                                append-icon="mdi-magnify"
                                color="primary"
                                :disabled="!filter.searchKey"
                                @keydown.enter="
                                    page = 1;
                                    search(true);
                                "
                                @click:append="
                                    page = 1;
                                    search(true);
                                "
                            />
                        </v-col>
                    </v-row>
                </div>

                <div>
                    <v-divider style="border-color: #222 !important" />
                    <div v-for="(order, index) in orders" :key="index">
                        <div class="py-5">
                            <v-row align="center">
                                <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 5">
                                    <v-img :src="order?.mainThumb" width="100%" max-width="300" :aspect-ratio="300 / 160" contain class="mx-auto"></v-img>
                                </v-col>
                                <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 5">
                                    <div class="font-size-16 font-size-md-18 grey--text text--darken-4 mb-3">
                                        <b>{{ order?.name }}</b>
                                    </div>
                                    <v-row no-gutters class="font-size-14 grey--text text--darken-2">
                                        <v-col cols="4"><b class="font-weight-medium">상품명</b></v-col>
                                        <v-col cols="8">{{ order?.productName }}</v-col>
                                    </v-row>
                                    <v-row no-gutters class="font-size-14 grey--text text--darken-2">
                                        <v-col cols="4"><b class="font-weight-medium">주문번호</b></v-col>
                                        <v-col cols="8">{{ order?.orderNo }}</v-col>
                                    </v-row>
                                    <v-row no-gutters class="font-size-14 grey--text text--darken-2 mt-1">
                                        <v-col cols="4"><b class="font-weight-medium">주문일시</b></v-col>
                                        <v-col cols="8">{{ $dayjs(order.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</v-col>
                                    </v-row>
                                    <v-row no-gutters class="font-size-14 grey--text text--darken-2 mt-1">
                                        <v-col cols="4"><b class="font-weight-medium">구매 금액</b></v-col>
                                        <v-col cols="8">{{ order?.totalAmount.format() }} 원</v-col>
                                    </v-row>
                                    <v-row no-gutters class="font-size-14 grey--text text--darken-2 mt-1">
                                        <v-col cols="4"><b class="font-weight-medium">구매 개수</b></v-col>
                                        <v-col cols="8">{{ order?.quantity.format() }} 개</v-col>
                                    </v-row>
                                    <v-row no-gutters class="font-size-14 grey--text text--darken-2 mt-1">
                                        <v-col cols="4"><b class="font-weight-medium">받는사람 연락처</b></v-col>
                                        <v-col cols="8">{{ order?.receiver.phone }}</v-col>
                                    </v-row>
                                    <v-row v-if="order.cashbill.status" no-gutters class="font-size-14 grey--text text--darken-2 mt-1">
                                        <v-col cols="4"><b class="font-weight-medium">현금영수증</b></v-col>
                                        <v-col cols="8"><span style="cursor: pointer; text-decoration: underline" @click="printCashbill(order)">출력하기</span></v-col>
                                    </v-row>
                                    <!-- <v-row no-gutters class="font-size-14 grey--text text--darken-2 mt-1">
                                        <v-col cols="4"><b class="font-weight-medium">주문상태</b></v-col>
                                        <v-col cols="8">{{ order.status }}</v-col>
                                    </v-row> -->
                                </v-col>
                                <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 2">
                                    <v-row align="center" justify="center">
                                        <v-col v-if="order.purchases.length" cols="auto">
                                            <mypage-dshop-order-dialog v-bind="{ _order: order._id }">
                                                <template #activator="{ attrs, on }">
                                                    <v-btn color="primary" v-bind="attrs" v-on="on">구매내역</v-btn>
                                                </template>
                                            </mypage-dshop-order-dialog>
                                        </v-col>
                                        <v-col v-if="order.status.indexOf('취소') < 0" cols="auto">
                                            <v-btn color="grey" dark @click="claim(order)">취소요청</v-btn>
                                        </v-col>
                                        <v-col cols="auto">
                                            <v-btn color="primary" dark>{{ order.status }}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                        <v-divider />
                    </div>
                </div>

                <div class="mt-30px mt-md-40px">
                    <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" />
                </div>
            </v-card>
        </v-responsive>
    </component>
</template>
<script>
import api from "@/api";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import MypageDshopOrderDialog from "@/components/client/mypage/dshop/mypage-dshop-order-dialog.vue";
export default {
    components: {
        VDateField,
        MypageDshopOrderDialog,
    },
    data() {
        return {
            page: 1,
            pageCount: 0,
            limit: 10,

            filter: {
                createdAt: ["", ""],
                searchKey: null,
                searchValue: null,
            },
            searchKeys: [
                { text: ":: 전체검색 ::", value: null },
                { text: "상품명", value: "name" },
            ],
            orders: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        async search(routable = false) {
            if (routable) {
                this.$router.push({
                    query: { page: this.page },
                });
            }
            let { summary, orders } = await api.v1.me.dshop.orders.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: {
                    ...this.filter,
                },
            });

            this.orders = orders.map(this.setOrder);
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        async claim(order) {
            if (await this.$confirm(`해당 주문 건에 취소요청 하시겠습니까?`)) {
                await api.v1.me.dshop.orders.cancel(order);
                await this.search(false);
                alert(`취소요청 처리되었습니다`);
            }
        },
        async printCashbill(order) {
            try {
                if (navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("iPhone") > -1) {
                    alert("PC에서 지원하는 기능입니다.");
                } else {
                    const { url } = await api.v1.me.shop.cashbill.print({ _id: order._id, params: { type: "delivery" } });

                    window.open(url, "", "width=800,height=640,scrollbars=yes");
                }
            } catch (error) {
                console.error(error);
            }
        },
        setOrder(order) {
            return {
                ...order,
                productName: order.purchases[0].product.name,
                mainThumb: this.setImgSrc(order?.purchases[0]?.curProduct?.thumb),
                quantity: order.pickups.reduce((acc, cur) => (acc += cur.quantity), 0),
                status: this.setStatus(order.purchases),
            };
        },
        setImgSrc(src) {
            // return `http://dev-giftcard.uxi.kr/${src}`;
            // return `https://dev-giftcard.uxi.kr/${src}`;
            return `https://daehanbooksgiftcard.com/${src}`;
        },
        setStatus(purchases) {
            const firstStatus = purchases[0].status;
            if (purchases.length === 1 || purchases.every(({ status }) => status === firstStatus)) return firstStatus;

            if (purchases.some(({ status }) => ["취소요청", "취소완료", "부분취소완료"].includes(status))) return "부분취소";

            return firstStatus;
        },
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.mypage}`);
        },
    },
};
</script>